import { DatePicker } from "antd";
import { Dayjs } from "dayjs";
import { convertDateToDayJs, formatDateForAPI } from "pages/EDCFlow/helper";
import useIsMobile from "pages/EDCFlow/hooks/useIsMobile";
import { useState } from "react";

type DatePickerInputProps = {
	disabled?: boolean;
	initialValue?: string;
	onChange: (value: string) => void;
	questionText: string;
	disabledDate?: (currentDate: Dayjs) => boolean;
	hasError?: boolean;
	addDefaultValue?: string;
	onAddDefault?: () => void;
};

const DatePickerInput = ({
	disabled = false,
	initialValue,
	onChange,
	questionText,
	disabledDate,
	hasError = false,
	addDefaultValue,
	onAddDefault
}: DatePickerInputProps) => {
	const hasDefault = addDefaultValue != null && onAddDefault != null;
	const initialDayjs = convertDateToDayJs(initialValue);
	const [value, setValue] = useState<Dayjs | null>(hasDefault ? null : initialDayjs);

	const handleChange = (date: Dayjs | null) => {
		setValue(date);
		const formattedValue = formatDateForAPI(date);
		onChange(formattedValue);
	};

	const handleAddDefault = () => {
		if (addDefaultValue != null && onAddDefault != null) {
			const defaultDate = convertDateToDayJs(addDefaultValue);
			if (defaultDate) {
				setValue(defaultDate);
				onAddDefault();
			}
		}
	};

	const isMobile = useIsMobile();

	return (
		<div className={`flex ${isMobile ? "flex-col" : "flex-row"} gap-2`}>
			<div className={`flex-1 ${hasError ? "edc-datepicker-error" : ""}`}>
				<DatePicker
					disabled={disabled}
					className="w-full"
					size="large"
					format="DD/MM/YYYY"
					placeholder="DD/MM/YYYY"
					value={value}
					onChange={handleChange}
					disabledDate={disabledDate}
					inputReadOnly={isMobile}
					placement={isMobile ? "bottomLeft" : "bottomLeft"}
					popupClassName={isMobile ? "mobile-datepicker-popup" : ""}
				/>
			</div>
			{hasDefault && (
				<span
					role="button"
					tabIndex={0}
					onClick={(e) => {
						e.preventDefault();
						handleAddDefault();
					}}
					className={`${
						isMobile ? "text-sm py-1" : ""
					} flex items-center cursor-pointer text-indigo-600 hover:text-indigo-700 whitespace-nowrap`}>
					Add default
				</span>
			)}
		</div>
	);
};

export default DatePickerInput;

